module.exports = "query Client ($id: String!) {\n  company (id: $id) {\n    id\n    name\n    status\n    social_reason\n    created_at\n    cnpj\n    contract\n    observation\n    balance\n    contact {\n      phone\n      name\n      email\n    }\n    address {\n      street\n      number\n      state\n      city\n      code\n    }\n    accounts {\n      id\n      name\n      created_at\n      end_date\n      enabledUsersCount\n      activeUsersCount\n      status\n      implantation\n      trial_end_date\n      trial_start_date\n    }\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/graphQL/queries/Client.graphql
// module id = Hm0g
// module chunks = 1624